var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 342,
    viewBox: "0 0 513 342",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_867)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -0.00585938H513V341.994H0V-0.00585938Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.3218 103.588L125.749 32.4472L138.229 40.7677L90.8025 111.908L78.3218 103.588ZM96.1069 115.444L143.534 44.3039L156.014 52.6244L108.588 123.765L96.1069 115.444ZM113.892 127.301L161.319 56.1606L173.799 64.4811L126.373 135.621L113.892 127.301ZM339.17 277.486L386.597 206.345L399.077 214.666L351.651 285.806L339.17 277.486ZM356.955 289.342L404.382 218.202L416.862 226.523L369.436 297.663L356.955 289.342ZM434.647 238.379L387.221 309.52L374.74 301.199L422.167 230.059L434.647 238.379Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M413.083 282.894L353.8 243.372L360.734 232.971L420.017 272.493L413.083 282.894Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.625 218.41C353.818 179.121 343.201 126.036 303.911 99.8431C264.622 73.65 211.537 84.267 185.344 123.557C159.151 162.846 169.768 215.931 209.058 242.124C248.348 268.317 301.432 257.7 327.625 218.41Z",
    fill: "#CA163A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.344 123.557C172.254 143.191 177.566 169.75 197.201 182.84C216.836 195.93 243.395 190.618 256.485 170.983C269.574 151.349 296.133 146.037 315.768 159.127C335.403 172.216 340.715 198.776 327.625 218.41C301.445 257.68 248.327 268.303 209.058 242.124C169.788 215.944 159.165 162.826 185.344 123.557Z",
    fill: "#0E4896"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M387.22 32.4473L434.647 103.588L422.166 111.908L374.739 40.7677L387.22 32.4473ZM369.435 44.3044L416.863 115.444L404.382 123.765L356.954 52.6249L369.435 44.3044ZM351.65 56.161L399.077 127.301L386.596 135.621L339.169 64.4815L351.65 56.161ZM126.372 206.346L173.799 277.486L161.318 285.807L113.891 214.666L126.372 206.346ZM108.587 218.203L156.013 289.343L143.533 297.663L96.1058 226.523L108.587 218.203ZM90.8025 230.059L138.229 301.2L125.749 309.52L78.3218 238.38L90.8025 230.059Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.192 263.845L134.977 251.989L117.192 263.845ZM357.266 103.796L378.039 89.947L357.266 103.796ZM395.824 78.0905L413.61 66.2339L395.824 78.0905Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M417.076 71.4342L399.291 83.2908L392.358 72.8901L410.143 61.0335L417.076 71.4342ZM381.506 95.1473L360.733 108.996L353.799 98.5954L374.572 84.7467L381.506 95.1473ZM138.444 257.19L120.659 269.046L113.725 258.645L131.51 246.789L138.444 257.19Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_867"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 342,
    fill: "white",
    transform: "translate(0 -0.00585938)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKr);
export default __webpack_public_path__ + "static/media/KR.31c3f3477be65af8fc2d11d0e20229b1.svg";
export { ForwardRef as ReactComponent };